import { Restaurant } from '../user-roles/user-roles.types';
import { Printer } from './restaurant.types';

export interface configData {
  calories: number;
  ingredients: string[];
}

export interface StationRequestType {
  name: string;
  restaurantId: number;
  config: configData;
}

export interface KdsRequestType {
  kdsIdentifier: string;
  name: string;
  stationsId: number[];
}

export interface UpdateMappingType {
  itemId: number[];
}

export interface StationItemsMappingType {
  id: number;
  stations: StationType;
  createdAt: Date;
  updatedAt: Date;
}

export interface StationType {
  id: number;
  name: string;
  config: configData;
  kds: KDSType[];
  createdAt: Date;
  updatedAt: Date;
  stationType: StationTypes;
}

export interface KDSType {
  id: number;
  kdsIdentifier: string;
  name: string;
  stations: StationType[];
  createdAt: Date;
  updatedAt: Date;
}

export interface GetMappingType {
  id: number;
  item: MappingItemType;
}

export interface MappingItemType {
  id: number;
}

export enum StationTypes {
  POS = 'pos',
  KDS = 'kds',
  PRINTER = 'printer',
  CASHDRAWER = 'cash-drawer',
}
export interface IConfigData {
  calories: number;
  ingredients: string[];
}
export interface IStation {
  id: number;
  name?: string;
  config?: IConfigData;
  restaurantId?: number;
  image?: string;
  kds?: IKDS[];
  restaurant?: Restaurant;
  stationType?: StationTypes;
  printers?: Printer[];
  excelStationId?: number;
  isDefault?: boolean;
}

export interface IKDS {
  id: number;
  kdsIdentifier?: string;
  restaurantDeviceId?: number;
  name?: string;
  stations?: IStation[];
  ipAddress?: string;
  serialNumber?: string;
  connectionStatus: boolean;
  displayAvgFulfillmentTime: boolean;
  doubleTabFullfill: boolean;
  ticketTimerYellow?: number;
  ticketTimerRed?: number;
  readyOrderTimer?: number;
  createdAt: Date;
  updatedAt: Date;
  restaurantId?: number;
  refreshToken?: string;
  restaurant?: Restaurant;
}
